<template>
  <modal
    name="linksLateralCreate"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="true"
  >
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="row">
          <ul class="tabs">
            <li class="tab-active">
              <a>Novo Link</a>
            </li>
          </ul>
        </div>
        <div class="form">
          <div class="row">
            <div class="col-1-2">
              <div class="form-group">
                <label for>
                  Descrição
                  <button
                    class="button-link"
                    v-on:click="changePrefixoMode"
                  >{{ prefixoBtnLabel }}</button>
                </label>
                <div class="row">
                  <div v-if="usePrefixo" class="col-1-2">
                    <input
                      type="text"
                      v-model="prefixo"
                      class="form-control"
                      placeholder="Prefixo (opcional)"
                    >
                  </div>
                  <div v-bind:class="{'col-1-2': usePrefixo}">
                    <input
                      type="text"
                      v-model="descricao"
                      class="form-control col-2-3"
                      placeholder="Descrição Principal"
                    >
                    <div class="message">{{ validation.firstError('descricao') }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-1-4">
              <div class="form-group">
                <label for>Aba</label>
                <select v-model="aba" class="form-control">
                  <option value>-</option>
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </select>
                <div class="message">{{ validation.firstError('aba') }}</div>
              </div>
            </div>
            <div class="col-1-4">
              <div class="form-group">
                <label for>Ordem</label>
                <input type="number" v-model="ordem" class="form-control">
                <div class="message">{{ validation.firstError('ordem') }}</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-1-2">
              <div class="form-group">
                <label for>Tipo de Link</label>
                <select v-model="tipo" class="form-control" @change="changeTipo">
                  <option value>-</option>
                  <option
                    v-for="(option, i) in this.tipos.labels"
                    v-bind:value="option"
                    v-bind:key="'t' + i"
                  >{{ option }}</option>
                </select>
              </div>
            </div>
            <div class="col-1-2">
              <div class="form-group">
                <label for>{{ tipo || '-' }}</label>
                <select v-model="link" class="form-control" :disabled="this.isLinkExterno()">
                  <option value selected disabled>Selecione um valor</option>
                  <option
                    v-for="(option, i) in tipoValues"
                    v-bind:value="option.url"
                    v-bind:key="'tt' + i"
                  >{{ option.titulo }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-1">
              <div class="form-group">
                <label for>Link</label>
                <input
                  type="text"
                  v-model="link"
                  class="form-control"
                  :disabled="!this.isLinkExterno()"
                >
                <!-- <div class="message">{{ validation.firstError('link') }}</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-actions">
            <button class="button button-success button-lg" v-on:click="handleSubmit">Inserir</button>
            <button class="button button-lg" v-on:click="handleClose">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { Validator } from "simple-vue-validator";

export default {
  name: "linksLateralCreate",
  props: {
    tipos: {
      default: function() {
        return { labels: [], values: [] };
      }
    },
    create: true,
    close: true
  },
  data() {
    return {
      descricao: "",
      aba: "",
      link: "",
      ordem: "",
      tipo: "",
      prefixo: "",
      usePrefixo: false,
      tipoValues: []
    };
  },
  validators: {
    // link: function(value) {
    //   return Validator.value(value).required();
    // },
    ordem: function(value) {
      return Validator.value(value)
        .required()
        .digit();
    },
    descricao: function(value) {
      return Validator.value(value).required();
    },
    aba: function(value) {
      return Validator.value(value).required();
    }
  },
  computed: {
    prefixoBtnLabel: function() {
      return !!this.usePrefixo
        ? "Remover Prefixo"
        : "Adicionar prefixo a descrição";
    }
  },
  methods: {
    handleClose() {
      this.prefixo = "";
      this.usePrefixo = false;
      this.descricao = "";
      this.aba = "";
      this.link = "";
      this.ordem = "";
      this.tipo = "";
      this.close();
    },
    handleSubmit() {
      this.$validate().then(success => {
        if (success) {
          this.create(
            this.descricao,
            this.link,
            this.ordem,
            this.aba,
            this.tipo,
            this.prefixo,
            this.usePrefixo
          );
          this.handleClose();
        }
      });
    },
    changePrefixoMode() {
      this.usePrefixo = !this.usePrefixo;
    },
    isLinkExterno() {
      return this.tipo === "Link Externo";
    },
    changeTipo() {
      if (this.isLinkExterno()) {
        this.tipoValues = [];
      } else {
        this.tipoValues = this.tipos.values[this.tipo];
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/Links/Cabecalho/Create.vue